// FullscreenToggle — Vollbild-Knopf für die Karte (Wave 14cb)
// ============================================================
//
// Wave 14cb-fix4: nur noch der Button selbst, keine absolute Positionierung.
// Wird von ZoomButtons direkt in den +/Zoom/− Stack eingehängt (User-Wunsch
// "den vollbild button direkt unter dem minus"). Selber Look wie die
// Zoom-Buttons (56 × 56 px), damit der Stack visuell konsistent wirkt.
//
// Tap toggled `fullscreenBus`, App.tsx + MapPage subscriben und blenden
// dementsprechend TabBar / BottomBar / Sheets aus.
//
// Icons: zwei klassische "expand" / "collapse" 4-Eck-Pfeile, lucide-style.
// Stroke-Width 2 wie der Rest der App.

import { useEffect, useState } from 'react';
import { fullscreenBus } from '../lib/fullscreenBus';

export function FullscreenToggle() {
  const [active, setActive] = useState(() => fullscreenBus.get());
  useEffect(() => {
    setActive(fullscreenBus.get());
    return fullscreenBus.subscribe(setActive);
  }, []);

  // Wave 14ca-fix64: rectangular + transparenter, matched zu den Zoom-
  // Buttons + Style-Switcher.
  return (
    <button
      type="button"
      onClick={() => fullscreenBus.toggle()}
      aria-label={active ? 'Exit fullscreen' : 'Enter fullscreen'}
      title={active ? 'Exit fullscreen' : 'Fullscreen map'}
      className="pointer-events-auto w-14 h-14 rounded-xl bg-turbo-900/35 border border-white/15 backdrop-blur-sm shadow-lg flex items-center justify-center text-white/90 hover:bg-turbo-900/55 active:bg-turbo-900/75 transition-colors"
    >
      {active ? <CollapseIcon /> : <ExpandIcon />}
    </button>
  );
}

/** Vier Pfeile nach aussen — "expand to fullscreen". */
function ExpandIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="15 3 21 3 21 9" />
      <polyline points="9 21 3 21 3 15" />
      <line x1="21" y1="3" x2="14" y2="10" />
      <line x1="3" y1="21" x2="10" y2="14" />
    </svg>
  );
}

/** Vier Pfeile nach innen — "collapse / exit fullscreen". */
function CollapseIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="4 14 10 14 10 20" />
      <polyline points="20 10 14 10 14 4" />
      <line x1="14" y1="10" x2="21" y2="3" />
      <line x1="3" y1="21" x2="10" y2="14" />
    </svg>
  );
}
